import { Form, FormRule } from "antd";
import Input, { TextInputProps } from "../TextInput/TextInput";

export default function FormItem({
  name,
  inputConfig,
  
  rules,
}: {
  name: string;
  label: string
  htmlFor?: string;
  inputConfig: TextInputProps;
  rules?: FormRule[];
}) {
  return (
    <Form.Item name={name} rules={rules}>
      <Input {...inputConfig} className={`!bg-[#F9FAFB] !h-[40px] !outline-none ${inputConfig.className}`} />
    </Form.Item>
  );
}
